import { render, staticRenderFns } from "./pagetitle.vue?vue&type=template&id=66428f86&scoped=true"
import script from "./pagetitle.vue?vue&type=script&lang=js"
export * from "./pagetitle.vue?vue&type=script&lang=js"
import style0 from "./pagetitle.vue?vue&type=style&index=0&id=66428f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66428f86",
  null
  
)

export default component.exports